import React from "react";
import L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
const apiDomain =
  window.leafletMapData?.apiDomain || "https://www.terraamericanart.org/";
const MAPTILER_KEY = "tIfN7w8Jm9Cu9tcAOjOK";
const MapWithClusters = () => {
  const mapRef = React.useRef();
  const [partners, setPartners] = React.useState([]);

  React.useEffect(() => {
    const fetchAllLocations = async () => {
      let allLocations = [];
      let page = 1;
      let totalPages = 1;

      try {
        while (page <= totalPages) {
          const response = await fetch(
            `${apiDomain}/wp-json/wp/v2/locations?per_page=100&page=${page}`
          );
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          allLocations = [...allLocations, ...data];

          // Get total pages from headers
          totalPages = parseInt(response.headers.get("X-WP-TotalPages"), 10);
          page++;
        }

        const formattedPartners = allLocations
          .filter((location) => location.acf && location.acf.map)
          .map((location) => {
            const grantTypes = location.grant_stats?.grant_types || {};
            return {
              city: location.acf.map.city || location.name,
              lat: location.acf.map.lat,
              lng: location.acf.map.lng,
              slug: location.slug,
              grants: grantTypes.grants ?? 0,
              collectionLoans:
                grantTypes["terra-foundation-collection-loan"] ?? 0,
            };
          });
        setPartners(formattedPartners);
        console.log("Fetched all locations:", formattedPartners);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchAllLocations();
  }, []);

  React.useEffect(() => {
    if (!mapRef.current) {
      const map = L.map("map", {
        attributionControl: false,
        scrollWheelZoom: false,
        minZoom: 2,
        maxZoom: 18,
        maxBounds: [
          [-85, -180],
          [85, 180],
        ],
        maxBoundsViscosity: 1.0,
      }).setView([40, 0], 2);

      L.tileLayer(
        `https://api.maptiler.com/maps/openstreetmap/256/{z}/{x}/{y}.png?key=${MAPTILER_KEY}`,
        {
          attribution:
            '&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          noWrap: true,
        }
      ).addTo(map);
      mapRef.current = map;
    }
    if (partners.length === 0) {
      console.log("No partners to add to the map.");
      return; // Exit early if partners is empty
    }

    const markers = L.markerClusterGroup({
      maxClusterRadius: 100,
      zoomToBoundsOnClick: true,
    });

    partners.forEach((partner) => {
      console.log("Adding marker for:", partner);
      const popupContentParts = [
        `<a class="map-marker-link" href="${apiDomain}/grants/?location=${partner.slug}"><b>${partner.city}</b></a>`,
      ];
      const statsParts = [];
      if (partner.grants > 0) {
        statsParts.push(`Grants: ${partner.grants}`);
      }
      if (partner.collectionLoans > 0) {
        statsParts.push(`Terra Collection Loans: ${partner.collectionLoans}`);
      }
      if (statsParts.length > 0) {
        popupContentParts.push(
          `<div class="map-marker-stats">${statsParts.join("<br>")}</div>`
        );
      }
      const popupContent = `<div>${popupContentParts.join("")}</div>`;
      const marker = L.marker([partner.lat, partner.lng]).bindPopup(
        popupContent
      );
      markers.addLayer(marker);
    });

    // map.addLayer(markers); });

    mapRef.current.addLayer(markers);
    console.log("Partners state updated:", partners);
  }, [partners]);

  return <div id="map"></div>;
};

export default MapWithClusters;
